export const htmlId: string = 'fixcenter-support-see-detail';